import clsx from 'clsx'

import styles from './RobotLoader.module.scss'

export const RobotLoader = () => {
  return <div className={clsx(styles.pool)} />
}
